import type { ReactNode } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface HeroProps {
  className?: string;
}

export function Hero({ className = '' }: HeroProps): ReactNode {
  const heroBackgroundUrl = resolveImagePath('/wp-content/uploads/2020/06/ASI_FBO_Main-copy-scaled.jpg');

  return (
    <section 
      className={`relative min-h-screen flex items-center justify-center overflow-hidden ${className}`}
      style={{
        backgroundImage: `url(${heroBackgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      
      {/* Hero Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
          Providing the Ultimate Client Experience is Our #1 Goal
        </h1>
        
        {/* Subtitle Content */}
        <div className="space-y-4 mb-8">
          <p className="text-lg md:text-xl text-white leading-relaxed">
            <span className="text-white">
              Comprehensive FBO, Maintenance, Avionics and Propeller Overhaul services just 10 minutes north of Louisville, KY
            </span>
          </p>
          <p className="text-lg md:text-xl text-white leading-relaxed">
            <span className="text-white">
              Come Experience Our NEW FBO Hangar Complex
            </span>
          </p>
        </div>

        {/* Testimonial Quote */}
        <div className="mb-12 max-w-3xl mx-auto">
          <div className="space-y-2">
            <p className="text-lg md:text-xl text-white italic font-semibold leading-relaxed">
              "One of the highlights of the Kentucky Derby this year was discovering Aircraft Specialists FBO…We will always keep Aircraft Specialists in mind for any charter flights we have going to/from Louisville."
            </p>
            <p className="text-lg md:text-xl text-white italic font-semibold">
              – Walter Johnson | Liberty Jet
            </p>
          </div>
        </div>
        
        {/* Call to Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://www.flightbridge.com/Go/ASI"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-3 text-sm font-medium text-white bg-primary hover:bg-primary-dark transition-colors duration-200 rounded shadow hover:shadow-md"
          >
            FBO RESERVATIONS
          </a>
          <a
            href="https://pfajets.com/book-now/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-3 text-sm font-medium text-white bg-transparent hover:bg-white/10 transition-colors duration-200 rounded shadow hover:shadow-md border-2 border-white"
          >
            SCHEDULE MAINTENANCE
          </a>
        </div>
      </div>
    </section>
  );
}